import { gql } from 'apollo-angular'

import { USER_FIELDS } from '../../fragments/user.fragment'

export const UPDATE_USER = gql`
  mutation updateUser(
    $id: Int!
    $autosave: Boolean!
    $data: mutationUserUpdateInput!
  ) {
    updateUser(id: $id, autosave: $autosave, data: $data) {
      ...UserFields
    }
  }
  ${USER_FIELDS}
`
